import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { IncentivesFilterScreenProps } from 'home/stack/types'
import { cloneDeep, isEqual } from 'lodash'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { useFiltersContext } from 'schedule/filters/context'
import { SingleSelectSettingView } from 'settings/screens/types/single_select/view'
import { SettingValue } from 'settings/types'
import { showHeaderButton } from 'shared/header/header_button'

export function IncentivesFilterScreen({
  route,
  navigation,
}: IncentivesFilterScreenProps) {
  const { theme } = useTheme()

  const {
    currentFilters,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
  } = useFiltersContext()
  const incentivesFilter = currentFilters['incentives']

  const [selectedId, setSelectedId] = useState<string>(
    incentivesFilter.selectedId
  )
  const [incentives, setIncentives] = useState<SettingValue[]>(
    incentivesFilter.values
  )

  const onSelectId = (value: SettingValue) => {
    setSelectedId(value.id)
  }

  const setPositionFilter = useCallback(() => {
    const newIncentivesFilter = {
      ...incentivesFilter,
      values: incentives,
      selectedId,
    }
    const newFilters = cloneDeep(currentFilters)
    if (
      !isEqual(
        newFilters['incentives'].selectedId,
        newIncentivesFilter.selectedId
      )
    ) {
      newFilters['incentives'] = newIncentivesFilter
      setCurrentFiltersWithToggle(newFilters)
      setCurrentSelectedPresetIndex(undefined)
    }
  }, [
    currentFilters,
    incentives,
    incentivesFilter,
    selectedId,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
  ])

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('done'),
        onPress: async () => {
          setPositionFilter()
          navigation.goBack()
        },
      }),
    [navigation, setPositionFilter, theme]
  )

  return (
    <SingleSelectSettingView
      selectedId={selectedId}
      values={incentives}
      onSelectValue={onSelectId}
    />
  )
}
